<div>
<h4>Calcolo automatico adempimenti</h4>
</div>

<div *ngIf="numPag==1">
    <div class="row">
        <div class="col-sm-12">
          &Egrave; possibile calcolare automaticamente i termini collegati
          <span *ngIf="!request.tipoAtto && !request.tipoEsito">alla {{entita.tipoScadenza.label}} {{entita.motivo.label}} del {{entita.dataScadenza | dateformatter:'DD/MM/YYYY'}} appena inserita.</span>
          <span *ngIf="request.tipoAtto || request.tipoEsito">alla "{{entita.tipoAtto ? entita.tipoAtto.label : entita.tipoEsito.label}}" sulla base delle date appena inserite:<br></span>
          <!--testo per atto-->
          <span *ngIf="request.tipoAtto && entita.dataNotifica">- Data notifica: {{entita.dataNotifica | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoAtto && entita.dataDeposito">- Data deposito: {{entita.dataDeposito | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoAtto && entita.dataPubblicazione">- Data pubblicazione: {{entita.dataPubblicazione | dateformatter:'DD/MM/YYYY'}}<br></span>
        <!--testo per esito-->

          <!-- <span *ngIf="request.tipoEsito && entita.dataDeposito">- Data deposito: {{entita.dataDeposito | dateformatter:'DD/MM/YYYY'}}<br></span> -->
          <span *ngIf="request.tipoEsito && entita.dataPronuncia">- Data pronuncia: {{entita.dataPronuncia | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoEsito && entita.dataPubblicazione">- Data pubblicazione: {{entita.dataPubblicazione | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoEsito && entita.dataComunicazione">- Data comunicazione: {{entita.dataComunicazione | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoEsito && entita.dataNotifica">- Data notifica: {{entita.dataNotifica | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoEsito && entita.dataTrasmissioneSentenza">- Data trasmissione sentenza: {{entita.dataTrasmissioneSentenza | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoEsito && entita.dataImpugnazione">- Data impugnazione: {{entita.dataImpugnazione | dateformatter:'DD/MM/YYYY'}}<br></span>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            Se si vuole procedere, selezionare le varianti di calcolo e cliccare su "Calcola", altrimenti cliccare su "Chiudi".
        </div>
    </div>
    <br>
<!--    <br>-->
<!--    <div class="row">-->
<!--        <div class="col-sm-12 container_conteggi wizard" style="padding-left: 60px;">-->
<!--            <div radioButtonInput [nameRadio]="'tipoPetitum'"-->
<!--                 [checkedRadioId]="flgAttore"-->
<!--                 [radioButtonOptions] ="attConv"-->
<!--                 (onReturn)="flgAttore = $event.id"-->
<!--                 [ngModel]="flgAttore" [classCol]="'col-sm-3'">-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--    <br>-->
    <form #f="ngForm" [formGroup]="sospensioniForm" (ngSubmit)="calcolaTermini();">
        <div class="row">
            <div checkBoxRadio class="col-sm-6" [labelInput]="'Abbreviazione dei termini'"
                idInput="abbreviazTermini" [objectReference]="abbreviazTermini" (onReturn)="abbreviazTermini = $event; changeRadioButton('abbreviazioneTermini')">
            </div>
           <div *ngIf="abbreviazTermini" naturalNumberInput class="col-sm-6" [(ngModel)]="request.giorniAbbreviazione" formControlName="giorniAbbreviazione"
                [labelInput]="'Giorni abbreviazioni'" [maxLength]="'4'" [checkFormat]="true" [allowNegative]="false" [minValue]="0" [type]="'number'" 
                [mandatory]="true">
            </div>
        </div>
        <div class="row">
            <div checkBoxRadio class="col-sm-6" [labelInput]="'Sospensione feriale'"
                 idInput="sospFeriale" [objectReference]="sospFeriale" (onReturn)="sospFeriale = $event; changeRadioButton('sospensioneFeriale')">
            </div>
        </div>
        <div class="row">
            <div checkBoxRadio class="col-sm-6" [labelInput]="'Sospensione personalizzata'"
                idInput="sospPersonalizzata" [objectReference]="sospensionePersonalizzata" (onReturn)="sospensionePersonalizzata = $event; changeRadioButton('personalizzata')">
            </div>
            <div *ngIf="sospensionePersonalizzata" datePickerInput class="col-sm-3" formControlName="dataSospensioneDa"
                [labelInput]="'Data da'"
                [mandatory]="true"
                [(ngModel)]="request.dataSospensioneDa">
            </div>
            <div *ngIf="sospensionePersonalizzata" datePickerInput class="col-sm-3"
                [mandatory]="true"
                [dataDal]="request.dataSospensioneDa"
                [labelInput]="'Data a'" formControlName="dataSospensioneA"
                [(ngModel)]="request.dataSospensioneA">
            </div>
        </div>

        <div class="row">
            <div checkBoxRadio class="col-sm-6" [labelInput]="'Santo patrono'"
                idInput="patrono" [objectReference]="patrono" (onReturn)="patrono = $event; changeRadioButton('patrono')">
            </div>
        </div>

        <div class="row">
            <div checkBoxRadio class="col-sm-3" [labelInput]="'Termine libero'"
                idInput="libero" [objectReference]="termineLibero" (onReturn)="termineLibero = $event; changeRadioButton('termineLibero')">
            </div>
        </div>

        <!--<div class="row" *ngIf="patrono">
            <div datePickerInput class="col-sm-6"
                [mandatory]="true"
               [labelInput]="'Data Santo Patrono'" formControlName="giornoPatrono"
               [(ngModel)]="request.giornoPatrono"></div>
        </div>-->
        <br>
        <div class="row">
            <p class="col-sm-3 col-xs-6">
            </p>
            <p submitButton [disabled]="!sospensioniForm.valid"
                class="col-sm-3 col-xs-6 col-sm-offset-6"
                [labelButton]="'Calcola'"></p>
        </div>
    </form>
</div>
<div *ngIf="numPag==2">

    <div class="row">
        <div class="col-sm-12">
            Di seguito sono elencati i termini calcolati automaticamente rispetto
          <span *ngIf="!request.tipoAtto && !request.tipoEsito">alla {{entita.tipoScadenza.label}} {{entita.motivo.label}} del {{entita.dataScadenza | dateformatter:'DD/MM/YYYY'}} appena inserita.</span>
          <span *ngIf="request.tipoAtto || request.tipoEsito">alla "{{entita.tipoAtto ? entita.tipoAtto.label : entita.tipoEsito.label}}" sulla base delle date appena inserite:<br></span>
          <!--testo per atto-->
          <span *ngIf="request.tipoAtto && entita.dataNotifica">- Data notifica: {{entita.dataNotifica | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoAtto && entita.dataDeposito">- Data deposito: {{entita.dataDeposito | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoAtto && entita.dataPubblicazione">- Data pubblicazione: {{entita.dataPubblicazione | dateformatter:'DD/MM/YYYY'}}<br></span>
        <!--testo per esito-->
          <span *ngIf="request.tipoEsito && entita.dataNotifica">- Data notifica: {{entita.dataNotifica | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoEsito && entita.dataDeposito">- Data deposito: {{entita.dataDeposito | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoEsito && entita.dataPubblicazione">- Data pubblicazione: {{entita.dataPubblicazione | dateformatter:'DD/MM/YYYY'}}<br></span>
          <span *ngIf="request.tipoEsito && entita.dataImpugnazione">- Data impugnazione: {{entita.dataImpugnazione | dateformatter:'DD/MM/YYYY'}}<br></span>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            Selezionare quali si desidera inserire nello scadenzario.
        </div>
    </div>
    <br>

    <div class="row" *ngIf="abbreviazTermini">
        <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
            [labelInput]="'Giorni abbreviazione'"
            [valueInput]="request.giorniAbbreviazione ? request.giorniAbbreviazione : ''">
        </div>
    </div>

    <div class="row" *ngIf="sospensionePersonalizzata" >
        <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'"
            [labelInput]="'Data sospensione personalizzata da'"
            [valueInput]="request.dataSospensioneDa ? request.dataSospensioneDa : ''">
        </div>
        <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'"
            [labelInput]="'Data sospensione personalizzata a'"
            [valueInput]="request.dataSospensioneA ? request.dataSospensioneA : ''">
        </div>
    </div>
    

    <!--<div *ngIf="isLoadingPag2" style="height: 150px">
        <div spinner-load [waiting]="true"></div>
    </div>-->

    <ng-container *ngIf="scadenzeTrovate.length > 0">
        <table class="table-striped table">
            <caption class="sr-only">Tabella scadenze trovate</caption>
            <tbody>
            <tr>
                <th style="width: 40%; display: table-cell; vertical-align: middle;">Adempimento proposto</th>
                <th style="width: 20%; display: table-cell; vertical-align: middle;">Calcolo su data</th>
                <th style="width: 20%; display: table-cell; vertical-align: middle;">Scadenza proposta</th>
                <th style="width: 20%"><div singleCheckBoxModInput [labelNotChecked]="'Seleziona tutti'" [labelChecked]="'Deseleziona tutti'" [objectReference]="checkSelezionati()" (onReturn)="gestisciSelezionaTutti($event)"></div></th>
            </tr>
            <tr *ngFor="let scadenzaAuto of scadenzeTrovate; let i = index">
                <td style="display: table-cell; vertical-align: middle;">{{scadenzaAuto.tipoAdempimento}}/{{scadenzaAuto.motivoAdempimento.label}}</td>
                <td style="display: table-cell; vertical-align: middle;">{{scadenzaAuto.tipoData.label}}</td>
                <td style="display: table-cell; vertical-align: middle;">{{ scadenzaAuto.data | dateformatter:'DD/MM/YYYY'}}
                    <span *ngIf="scadenzaAuto.abbreviazioneTermini"><sup>(1)</sup></span>
                    <span *ngIf="scadenzaAuto.sospensioneFeriale"><sup>(2)</sup></span>
                    <span *ngIf="scadenzaAuto.termineLibero"><sup>(3)</sup></span>
                    <span *ngIf="scadenzaAuto.giornoPatrono"><sup>(4)</sup></span>
                    <span *ngIf="scadenzaAuto.sospensionePersonalizzata"><sup>(5)</sup></span>
                </td>
                <td>
                    <div singleCheckBoxModInput [objectReference]="scadenzeTrovate[i].selezionato"(onReturn)="scadenzaAuto.selezionato = $event; addScadenza(scadenzaAuto)"></div>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="row">
            <div class="col-sm-12">
                (1) Applicata abbreviazione dei termini
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                (2) Applicata sospensione feriale
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                (3) Applicato termine libero
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                (4) Applicato Santo Patrono
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                (5) Applicata sospensione personalizzata
            </div>
        </div>
        <br>
    </ng-container>
    <ng-container *ngIf="scadenzeTrovate.length == 0">
        <div class="row">
            <div class="col-sm-12" style="text-align: center">
                Nessun risultato
            </div>
        </div>
    </ng-container>

    <div class="row">
        <p class="col-sm-3 col-xs-3">
            <button type="button" class="btn btn-outline-secondary btn-block"  (click)="indietro()">Indietro</button>
        </p>
        <div class="col-sm-3 col-xs-6 col-sm-offset-6">
            <button type='Submit' class='btn btn-primary btn-block' [disabled]='scadenzeSelezionate.length == 0' (click)="inserisciTermini()">
                Inserisci
            </button>
        </div>
    </div>
</div>



